import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({
    name: 'currencyFormat'
})
export class CurrencyFormatPipe implements PipeTransform {

    transform(num: number): string {
        let returnValue: string;
        const pipe = new DecimalPipe('en-US');
        // tslint:disable-next-line: max-line-length
        // Condition removed for Bug-92950 [Solution Summary]:- Discrepancy in Implementation of Total Solution Value calculation between PBI and application.
        // if (num < 0) {
        //     num = num * -1;
        // }
        if (num < 0) {
            if (num >= -999) {
                returnValue = pipe.transform(num, '1.0-2');
            } else if (num <= -1000 && num >= -999999) {
                returnValue = pipe.transform((num / 1000), '1.0-2') + 'K'; // thousands
            } else if (num <= -1000000 && num >= -999999999) {
                returnValue = pipe.transform((num / 1000000), '1.0-2') + 'M'; // millions
            } else if (num <= -1000000000 && num >= -999999999999) {
                returnValue = pipe.transform((num / 1000000000), '1.0-2') + 'Bn'; // billions
            } else if (num <= -1000000000000) {
                returnValue = pipe.transform((num / 1000000000000), '1.0-2') + 'Tn'; // trillions
            }
        } else if (num <= 999) {
            returnValue = pipe.transform(num, '1.0-2');
        } else if (num >= 1000 && num <= 999999) {
            returnValue = pipe.transform((num / 1000), '1.0-2') + 'K'; // thousands
        } else if (num >= 1000000 && num <= 999999999) {
            returnValue = pipe.transform((num / 1000000), '1.0-2') + 'M'; // millions
        } else if (num >= 1000000000 && num <= 999999999999) {
            returnValue = pipe.transform((num / 1000000000), '1.0-2') + 'Bn'; // billions
        } else if (num >= 1000000000000) {
            returnValue = pipe.transform((num / 1000000000000), '1.0-2') + 'Tn'; // trillions
        } else {
            if (num !== undefined) {
                returnValue = num.toString();
            } else {
                returnValue = '';
            }
        }
        return returnValue;
    }

}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/shared/pipes/currency-format.pipe.ts